import Swal, { SweetAlertOptions } from 'sweetalert2'

/**
 * SweetAlert2 エラー用ダイアログ
 * @param {SweetAlertOptions} options
 *
 * e.g.
 * `swalError({text: 'エラーが発生しました'})`
 */
export const swalError = function (options: SweetAlertOptions) {
  return Swal.mixin({ icon: 'error', ...options }).fire()
}
